export enum ChartTypes {
  AstronautOverviewLineChart = 'AstronautOverviewLineChart',
  AstronautOverViewStatusChart = 'AstronautOverViewStatusChart',
  ADELineChart = 'ADELineChart',
  ADEStatusChart = 'ADEStatusChart',
  VDELineChart = 'VDELineChart',
  KPITimeLine = 'KPITimeLIne',
  KPILineChart = 'KPILineChart',
  VectorSystem = 'VectorSystem',
  AstronautA5Next = 'AstronautA5Next',
  CardKpiLine = 'CardKpiLIne',
}

export enum ChartsWithoutLeftContainerOffset {
  AstronautA5Next = `AstronautA5Next`,
  KPILineChart = `KPILineChart`,
  KPITimeLine = `KPITimeLine`,
  VDELineChart = `VDELineChart`,
  ADELineChart = 'ADELineChart',
  ADEStatusChart = 'ADEStatusChart',
  AstronautOverviewLineChart = 'AstronautOverviewLineChart',
  VectorSystem = 'VectorSystem',
  CardKpiLine = 'CardKpiLIne',
}

export enum ChartsWithRightContainerOffset {
  VectorSystem = 'VectorSystem',
  AstronautA5Next = 'AstronautA5Next',
  KPILineChart = 'KPILineChart',
  VDELineChart = 'VDELineChart',
  AstronautOverviewLineChart = 'AstronautOverviewLineChart',
  ADELineChart = 'ADELineChart',
  ADEStatusChart = 'ADEStatusChart',
}
